// 자주 찾는 핫플 지역 — 캐치테이블·다이닝코드처럼 지역 칩을 1차 탐색 수단으로 쓴다.
// 좌표는 각 지역의 대표 지점(역/거리 중심).
export interface HotRegion {
  name: string;
  x: number; // 경도
  y: number; // 위도
}

export const HOT_REGIONS: HotRegion[] = [
  { name: '홍대', x: 126.924, y: 37.5573 },
  { name: '강남', x: 127.0276, y: 37.4979 },
  { name: '연남', x: 126.9214, y: 37.5623 },
  { name: '성수', x: 127.0557, y: 37.5446 },
  { name: '을지로', x: 126.991, y: 37.5663 },
  { name: '이태원', x: 126.9944, y: 37.5345 },
  { name: '압구정', x: 127.0406, y: 37.5273 },
  { name: '합정', x: 126.9139, y: 37.5496 },
  { name: '건대', x: 127.0703, y: 37.5404 },
  { name: '잠실', x: 127.1, y: 37.5133 },
  { name: '신촌', x: 126.9368, y: 37.5551 },
  { name: '여의도', x: 126.9244, y: 37.5216 },
  // 2026-06 확장 — Kakao 밀도·거리 검증으로 선별한 핫플 (도심·서남·강남·성동권).
  { name: '가로수길', x: 127.0208, y: 37.5169 },
  { name: '샤로수길', x: 126.9527, y: 37.4813 },
  { name: '서촌', x: 126.9731, y: 37.5787 },
  { name: '삼청동', x: 126.9848, y: 37.5818 },
  { name: '대학로', x: 127.0019, y: 37.582 },
  { name: '익선동', x: 126.9898, y: 37.5734 },
  { name: '종로', x: 126.9922, y: 37.5704 },
  { name: '명동', x: 126.9849, y: 37.5621 },
  { name: '망원', x: 126.9059, y: 37.5537 },
  { name: '문래', x: 126.8978, y: 37.514 },
  { name: '한남', x: 127.0092, y: 37.5294 },
  { name: '서울숲', x: 127.0376, y: 37.5443 },
  { name: '커먼그라운드', x: 127.0657, y: 37.5411 },
];

// 계정 동기화의 로컬 캐시/폴백 키. 기존 즐겨찾기 데이터와 동일 키를 재사용해
// 서버 미연결(401/404/오프라인) 시에도 사용자가 등록한 지역이 유지된다.
export const PREFERRED_REGIONS_KEY = 'moiza.favoriteRegions';

const FAVORITES_KEY = PREFERRED_REGIONS_KEY;

/** 주로 가는 지역 — 기기 로컬 캐시. 실패해도 기능은 동작해야 하므로 조용히 빈 배열. */
export function loadFavoriteRegions(): string[] {
  try {
    const raw = localStorage.getItem(FAVORITES_KEY);
    const parsed: unknown = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((n): n is string => typeof n === 'string');
  } catch {
    return [];
  }
}

export function saveFavoriteRegions(names: readonly string[]): void {
  try {
    localStorage.setItem(FAVORITES_KEY, JSON.stringify(names));
  } catch {
    // 저장 불가(사파리 프라이빗 등) — 즐겨찾기만 비활성, 치명적이지 않음
  }
}

/** 즐겨찾기 우선 + 나머지 원래 순서 — 새 배열 반환 */
export function orderByFavorites(regions: readonly HotRegion[], favorites: readonly string[]): HotRegion[] {
  const favSet = new Set(favorites);
  return [...regions.filter((r) => favSet.has(r.name)), ...regions.filter((r) => !favSet.has(r.name))];
}
